module.exports = __webpack_public_path__ + "static/chalmers-a77467f1639a75637788451c55dcf998.png";